import { createTicks } from "@/app/activity/components/timeline/activityTimeline/utils"
import { TimelineTickProps } from "@/app/activity/components/timeline/activityTimeline/type"
import { colors } from "@/components/colors"

import "./timelineTick.scss"

export default function TimelineTick({
  rangeKey,
  width,
  dateStart,
  dateFinish,
  transform,
}: TimelineTickProps) {
  const ticks = createTicks(width, rangeKey, dateFinish, dateStart)

  return (
    <g className="TimelineTickCont" transform={transform}>
      {ticks.map((tick, index) => (
        <g key={(tick.x || 0) + index}>
          {tick.text && (
            <text x={(tick.x || 0) - 15} y="35" className="timeline-time">
              {tick.text}
            </text>
          )}

          {tick.text && (
            <line
              x1={tick.x}
              y1="37"
              x2={tick.x}
              y2="45"
              stroke={colors.platinum[300]}
              strokeWidth="1"
            />
          )}
        </g>
      ))}
      <line x1="0" y1="46" x2={width} y2="46" stroke={colors.platinum[300]} strokeWidth="1" />
    </g>
  )
}
